import pad from './pad';
export default ((dateString, type) => {
    const [year, month = 1, date = 1] = dateString.split('-');
    return `${year}-${pad(month)}-${pad(date)}`.substr(0, {
        date: 10,
        month: 7,
        year: 4
    }[type]);
});
